export default __webpack_public_path__ + "static/media/splash-register-left.e7838f77.svg";